<template>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <li>
        <router-link
          to="/"
          v-slot="{ href, navigate, isActive, isExactActive }"
          custom
          exact
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-speedometer"></i>
            <!--span class="badge badge-pill badge-success float-right">3</span-->
            <span>Dashboard</span>
          </a>
        </router-link>
      </li>

      <!-- <li>
        <router-link
          to="/achat"
          v-slot="{ href, navigate, isActive, isExactActive }"
          custom
          exact
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-cube"></i>
            <span>Module Achats</span>
          </a>
        </router-link>
      </li> -->

      <!-- <li>
        <router-link
          to="/crm"
          v-slot="{ href, navigate, isActive, isExactActive }"
          custom
          exact
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-cube"></i>
            <span>Module CRM</span>
          </a>
        </router-link>
      </li> -->

      <!--li>
        <router-link
          to="/gmao"
          v-slot="{ href, navigate, isActive, isExactActive }"
          custom
          exact
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-cube"></i>
            <span>Module GMAO</span>
          </a>
        </router-link>
      </li-->

      <!-- <li>
        <router-link
          to="/gpao"
          v-slot="{ href, navigate, isActive, isExactActive }"
          custom
          exact
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-cube"></i>
            <span>Module GPAO</span>
          </a>
        </router-link>
      </li> -->

      <li>
        <router-link
          to="/rh"
          v-slot="{ href, navigate, isActive, isExactActive }"
          custom
          exact
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-cube"></i>
            <span>Module RH</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          to="/client"
          v-slot="{ href, navigate, isActive, isExactActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-cube"></i>
            <span>Clients</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          to="/chantier"
          v-slot="{ href, navigate, isActive, isExactActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-cube"></i>
            <span>Chantiers</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          to="/remplacement"
          v-slot="{ href, navigate, isActive, isExactActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="fa fa-cube"></i>
            <span>Remplacements</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          to="/configuration"
          v-slot="{ href, navigate, isActive, isExactActive }"
          class="side-nav-link-ref"
          active-class="active"
          exact-active-class="active"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-settings"></i>
            <span>Configurations</span>
          </a>
        </router-link>
      </li>
    </ul>
  </div>
  <!-- Sidebar -->
</template>
<script>
import MetisMenu from 'metismenujs/dist/metismenujs';
export default {
  components: {},
  mounted() {
    // eslint-disable-next-line no-unused-vars
    new MetisMenu('#side-menu');
    /*  var elems = document.querySelectorAll(".mm-active");
console.log(elems.length);
    [].forEach.call(elems, function(el) {
        el.classList.remove("mm-active");
    });
    
      console.log(elems.length);
      */
    // this.loadJS();
  },
  methods: {
    loadJS() {},
    lightSidebar() {
      document.body.setAttribute('data-topbar', 'dark');
      document.body.removeAttribute('data-sidebar');
      document.body.removeAttribute('data-layout-size', 'boxed');
      document.body.removeAttribute('data-sidebar-size', 'small');
      document.body.classList.remove('vertical-collpsed');
    },
    compactSidebar() {
      document.body.setAttribute('data-sidebar-size', 'small');
      document.body.setAttribute('data-sidebar', 'dark');
      document.body.removeAttribute('data-layout-size', 'boxed');
      document.body.classList.remove('vertical-collpsed');
      document.body.removeAttribute('data-topbar', 'dark');
    },
    iconSidebar() {
      document.body.setAttribute('data-keep-enlarged', 'true');
      document.body.classList.add('vertical-collpsed');
      document.body.setAttribute('data-sidebar', 'dark');
      document.body.removeAttribute('data-topbar', 'dark');
      document.body.removeAttribute('data-layout-size', 'boxed');
    },
    boxedLayout() {
      document.body.setAttribute('data-keep-enlarged', 'true');
      document.body.classList.add('vertical-collpsed');
      document.body.setAttribute('data-layout-size', 'boxed');
      document.body.setAttribute('data-sidebar', 'dark');
      document.body.removeAttribute('data-topbar', 'dark');
    },
  },
};
</script>
<style scoped>
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid #e7eaed;
}

.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-header + .list-group .list-group-item:first-child {
  border-top: 0;
}

.card-custom-primary {
  color: black;
  background-color: #c2a533a1;
}
.list-group-item-action {
  color: black;
}

#side-bar a:active {
  color: #ad932f !important;
}
</style>
